import React from "react";
import { SeasonContext } from "ui/componentes/";
import { SeasonFormDefault, useCurrentSeason } from "api";

const SeasonProvider = ({ children }) => {
    const currentSeason = useCurrentSeason();
    return (
        <SeasonContext.Provider
            value={{ ...SeasonFormDefault, ...currentSeason }}
        >
            {children}
        </SeasonContext.Provider>
    );
};

export { SeasonProvider };
